import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { IfPermission, coreEvents } from '@folio/stripes/core';
import { CopyListPage, CreateListPage, EditListPage, ListInformationPage, ListPage, MissingAllEntityTypePermissionsPage, } from './pages';
import { useRecordTypes } from './hooks';
export var ListsApp = function (props) {
    var path = props.match.path;
    var _a = useRecordTypes(), recordTypes = _a.recordTypes, isLoading = _a.isLoading;
    if (!isLoading && (recordTypes === null || recordTypes === void 0 ? void 0 : recordTypes.length) === 0) {
        return React.createElement(MissingAllEntityTypePermissionsPage, null);
    }
    return (React.createElement(Switch, null,
        React.createElement(Route, { path: path, exact: true, render: function () { return (React.createElement(IfPermission, { perm: "lists.item.get" /* USER_PERMS.ReadList */ },
                React.createElement(ListPage, null))); } }),
        React.createElement(Route, { path: "".concat(path, "/list/:id"), exact: true, render: function () { return (React.createElement(IfPermission, { perm: "lists.item.get" /* USER_PERMS.ReadList */ },
                React.createElement(ListInformationPage, null))); } }),
        React.createElement(Route, { path: "".concat(path, "/list/:id/edit"), exact: true, render: function () { return (React.createElement(IfPermission, { perm: "lists.item.update" /* USER_PERMS.UpdateList */ },
                React.createElement(EditListPage, null))); } }),
        React.createElement(Route, { path: "".concat(path, "/list/:id/copy"), exact: true, render: function () { return (React.createElement(IfPermission, { perm: "lists.item.update" /* USER_PERMS.UpdateList */ },
                React.createElement(CopyListPage, null))); } }),
        React.createElement(Route, { path: "".concat(path, "/new"), exact: true, render: function () { return (React.createElement(IfPermission, { perm: "lists.collection.post" /* USER_PERMS.CreateList */ },
                React.createElement(CreateListPage, null))); } })));
};
ListsApp.eventHandler = function (event) {
    if (event === coreEvents.LOGIN) {
        sessionStorage.clear();
    }
};
export default ListsApp;
